import { Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
// Removed useMemo, PermissionProvider, useAuthStore, useUser, useMercureSync

export function RootLayout() {
  // All auth, user data, and Mercure sync logic moved to BootLoader
  // console.log("yo"); // Removed

  return (
    <>
      {" "}
      {/* No PermissionProvider wrapper here anymore */}
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}
